var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    className: "svg-icon ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 17.9c-.22.28-.72.42-1.5.42-.23 0-.53-.03-.9-.1v-.87c.26.04.52.06.78.06.41 0 .67-.06.78-.17.12-.18.17-.48.17-.92v-.27c-.22.3-.52.44-.9.44-.4 0-.7-.13-.89-.38a2.56 2.56 0 01-.22-1.25v-2.05c0-.65.09-1.08.28-1.3.18-.28.48-.43.9-.43.4 0 .76.2 1.06.6l.05-.44h.73v5.08c0 .8-.11 1.32-.34 1.57zm-3.97-1.41l-1.4-3.57v3.57H8.78V8.92h1.07v3.62l1.4-3.62h1.06l-1.45 3.9 1.5 3.67h-1.11zm-.67-11.35c0-.4.13-.73.39-.98.26-.29.6-.43 1-.43.42 0 .75.14 1.01.43.3.25.45.58.45.98 0 .5-.26.91-.78 1.24h-1.29c-.52-.29-.78-.7-.78-1.24zm-1.8 0c0 .4.1.8.28 1.24H7.27c-.37 0-.73.12-1.06.38-.34.21-.56.48-.67.8l-2.47 11.2c-.11.36-.1.65.06.86.18.25.46.38.84.38h16.01c.38 0 .66-.13.84-.38.2-.21.23-.5.12-.86l-2.52-11.2c-.12-.32-.34-.59-.68-.8-.33-.26-.69-.38-1.06-.38h-1.74a2.97 2.97 0 00-.67-3.46 3.19 3.19 0 00-2.3-.92c-.85 0-1.6.3-2.23.92a2.97 2.97 0 00-.96 2.22zm5.77 7.18c-.15-.18-.31-.27-.5-.27-.3 0-.45.18-.45.54v2.33c0 .29.04.45.11.49.04.07.13.1.28.1.19 0 .38-.1.56-.32v-2.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weight-icon.3257eb832f848ed77835eb7a81adbfd9.svg";
export { ForwardRef as ReactComponent };